export const siteInfo = {
  name: "黑料官方",
  fullName: "黑料官方 · 声明辟谣澄清信息平台",
  tagline: "传闻四起时，先看官方口径",
  intro:
    "黑料官方把散落各处的正式表态收拢到一处：官方声明、官方回应、辟谣澄清与公告通知的原文，按时间与类别归档，方便你在第一时间核对事实，而不是被截屏和二传三传牵着走。",
  email: "clarify@heiliao-official.com",
  reportEmail: "report@heiliao-official.com",
  serviceHours: "工作日 09:30 - 18:30",
  updatedAt: "2026-09-11",
  stats: [
    { label: "已归档公告", value: "1,286", unit: "篇" },
    { label: "已核实传闻", value: "942", unit: "条" },
    { label: "平均响应时长", value: "6.5", unit: "小时" },
    { label: "信息源可追溯率", value: "100", unit: "%" },
  ],
};

export const principles = [
  {
    title: "原文优先",
    description: "每条公告都保留完整原文与发布时间，不做删改和二次演绎，方便逐句比对。",
    icon: "ri-file-text-line",
  },
  {
    title: "来源可溯",
    description: "标注发布渠道、归档编号与核实结论，让每一条说法都能找到出处。",
    icon: "ri-links-line",
  },
  {
    title: "及时同步",
    description: "传闻出现后，官方表态一经确认即同步上线，减少信息空窗期。",
    icon: "ri-refresh-line",
  },
  {
    title: "就事论事",
    description: "只回应可核查的事实问题，不扩散情绪，不追加未经证实的推断。",
    icon: "ri-scales-3-line",
  },
] as const;

export const testimonials = [
  {
    quote:
      "做内容审核时最怕拿到的是三手截图。这里能直接翻到原文和发布时间，核实效率高了很多。",
    author: "林女士",
    role: "媒体内容编辑",
  },
  {
    quote:
      "合作方被卷入传闻，我们在声明库里两分钟就找到了官方口径，沟通时心里有底。",
    author: "周先生",
    role: "品牌公关负责人",
  },
  {
    quote:
      "分类和搜索都挺清楚，关键词一输就能定位到对应的辟谣条目，不用来回翻动态。",
    author: "陈同学",
    role: "关注网络信息的普通用户",
  },
] as const;